/* eslint-disable max-len */
import React, {Component} from 'react';
import {autobind} from 'core-decorators';
import {graphql} from 'react-apollo';
import PropTypes from 'prop-types';
import Popup from 'components/popup';
import userQuery from 'graphql/queries/user.gql';
import SectionTitle from 'components/section-title';
import Button from 'components/button';
import {OrganizationSelect} from 'components/forms';
import styles from './styles.css';

const getStorageKey = userId => `redin.tutorial.${userId}`;

@graphql(userQuery)
@autobind
export default class InitialOrganizationSelector extends Component {
    static propTypes = {
        onSessionOrganizationChange: PropTypes.func,
    };

    state = {
        visible: true,
    };

    handleOnChange(step) {
        this.setState({step});
    }

    handleClose() {
        this.setState({visible: false});
    }
    renderStep(index) {

        const steps = [
            (
                <div className={styles.content}>
                    <div className={styles.title}>
                        <SectionTitle title='Seleccione la organización' />
                    </div>
                    <div className={styles.organization}>
                        {this.props.onSessionOrganizationChange && (
                            <OrganizationSelect
                                value={this.props.data.user.organization.id}
                                onChange={this.props.onSessionOrganizationChange}
                                clearable={false}
                                variables={{includeOwn: true}}
                            />
                        )}
                    </div>
                    <p>
                        Una vez seleccionado uno de tus multiplicadores podrás hacer todos los pedidos que quieras
                        en su nombre.
                    </p>
                    <p>
                        Podrás siempre ver el <strong>historial de pedidos</strong> realizados accediendo desde
                        el menú del portal.
                    </p>
                    <p>
                        Si accedés a <strong>historial de pedidos</strong> como un multiplicador especifico,
                        sólo verás lo referente a ese multiplicador.
                    </p>
                    <Button className={styles.button} theme='yellow' onClick={this.handleClose}>
                        Seleccionar
                    </Button>
                </div>
            ),
        ];
        return steps[index];
    }

    render() {

        return (
            <Popup visible={this.state.visible}>
                <div className={styles.root}>
                    <button onClick={this.handleClose} theme='white'>
                        <i className='material-icons'>close</i>
                    </button>
                    {this.renderStep(0)}
                </div>
            </Popup>
        );
    }
}



// WEBPACK FOOTER //
// ./components/initial-organization-selector/index.js